export const ROUTES = {
  home: '/',
  signin: '/sign-in',
  passwordReset: '/password-reset',
  passwordRestore: '/password-restore',
  cohortMarketingPerformance: '/cohort-marketing-performance',
  calendarInsights: '/calendar-insights',
  datasources: '/datasources',
  userManagement: '/user-management',
  userSettings: '/user-settings',
  cohortRetention: '/cohort-retention',
  roiBreakdown: '/roi-breakdown',
  cohortChart: '/cohort-chart',
  calendarChart: '/calendar-chart',
  cohortScanner: '/cohort-scanner',
  productsCatalog: '/products',
  organizationInfo: '/organization',
  dashboards: '/dashboards',
  overview: '/overview',
};
